import "./frame.css";

/**
 * The shell's frame (`frame.css`): the class names of the pieces the authenticated shell and the
 * public authentication screens draw the same way, so both load the one stylesheet by naming them
 * (2026-09-27). The ground is the chrome surface in both themes and the sheet the themed work
 * surface inset and rounded on it. The product's marks they both draw are `@baton/brand`'s
 * (2026-09-28).
 */
export const frameGroundClassName = "b-chrome";
export const frameSheetClassName = "b-frame-sheet";
